// «A crédito / Enganche hoy» de la tarjeta SureKeep en Forma de pago. Puro, sin React.
import { minDownPaymentCents } from './downPaymentBounds';
import { quotePriceCentsOf } from './quoteHeadline';
import { isSureKeepConfirmed } from './sureKeepAvailability';
import type { CatalogResponse, WizardSession } from './types';

export interface SureKeepSplit {
    /** Lo que financia SureKeep con el enganche mínimo del plan. */
    creditCents: number;
    /** Enganche mínimo más lo que no entra al crédito. */
    downPaymentTodayCents: number;
}

/**
 * Reparto con el enganche mínimo del nivel; lo que pase del tope de crédito va al enganche.
 * `undefined` sin nivel, sin reparto del servidor o sin el % del plan.
 */
export function sureKeepSplitOf(
    session: WizardSession,
    saleTotalCents: number,
    catalog: Pick<CatalogResponse, 'minDownPaymentPct' | 'creditCapCents'> | undefined,
    lostDiscountCents = 0,
): SureKeepSplit | undefined {
    if (!isSureKeepConfirmed(session)) return undefined;
    const quoted = quotePriceCentsOf(session);
    // Lo que SureKeep no admite (p. ej. una promo solo contado) sube el precio a financiar.
    const priceCents = quoted === undefined ? undefined : quoted + lostDiscountCents;
    const totalCents = saleTotalCents + lostDiscountCents;
    const pct = catalog?.minDownPaymentPct;
    if (priceCents === undefined || pct === undefined) return undefined;
    const down = Math.min(
        priceCents,
        minDownPaymentCents(priceCents, pct, catalog?.creditCapCents),
    );
    return {
        creditCents: priceCents - down,
        downPaymentTodayCents: Math.max(0, down + (totalCents - priceCents)),
    };
}
